<template>
  <v-container
    fluid
    id="data-tables"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <base-v-component
          heading="Список логов"
        />
        <base-material-card
          color="primary"
          icon="mdi-script"
          inline
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Список логов
            </div>
          </template>

          <v-data-table
            :headers="headers"
            :items="items"
            :search.sync="search"
            multi-sort
            :footerProps="datatable_footer"
          >
          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
            {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
            </template>
            <template v-slot:top>
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="2"  xl="2">
                      <v-text-field
                        v-model="form.date.from"
                        label="Дата начала"
                        type="date"
                        @keyup.enter="load"
                      />
                    </v-col>
                    <v-col cols="12" md="2" xl="2">
                      <v-text-field
                        v-model="form.date.to"
                        label="Дата конца"
                        type="date"
                        @keyup.enter="load"
                      />
                    </v-col>                
                    <v-col cols="12" md="3"  xl="2">
                      <v-select
                        v-model="form.type"
                        label="Тип"
                        :items="select.types"
                        clearable
                        @keyup.enter="load"
                      />
                    </v-col>
                    <v-col cols="12"  md="3"  xl="2">
                      <v-select
                        v-model="form.creator"
                        label="Пользователь"
                        :items="select.users"
                        clearable
                        @keyup.enter="load"
                      />
                    </v-col>
                    <v-col cols="12" md="1" xl="2">
                      <v-text-field
                        v-model="form.entity"
                        label="Объект"
                        type="text"
                        clearable
                        @keyup.enter="load"
                      />
                    </v-col>
                    
                    <v-col cols="12" md="2" xl="1">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        @click="load"
                      >
                        Поиск
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-btn
                        color="secondary"
                        dark
                        min-width="250"
                        class="mb-2"
                        @click="clear"
                      >
                        Сбросить фильтры
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon
                color="primary"
                class="mr-2"
                large
                @click="dialog.item = item, dialog.show = true"
              >
                mdi-eye
              </v-icon>
            </template>
            <template v-slot:item.filter="{ item }">
              <v-icon
                large
                color="primary"
                style="font-size: 26px;"
                @click="form.entity = item.entity, load()"
              >
                mdi-filter-outline
              </v-icon>
              {{ item.state_string }}
            </template>
            
            <template v-slot:item.date="{item}">
              <div class="table_item">
                <span class="table_item__title">
                  {{ item.date_text }}
                </span>
              </div>
            </template>
            <template v-slot:item.type="{item}">
              <div class="table_item">
                <span class="table_item__title">
                  {{ $store.state.dict.log[item.type] }}
                </span>
              </div>
            </template>
            <template v-slot:item.user="{item}">
              <div class="table_item">
                <span class="table_item__title" v-if="item.user">
                  {{ (item.user.surname ? item.user.surname + " " : "") + item.user.name }}
                </span>
              </div>
            </template>
          </v-data-table>
        </base-material-card>
        <v-dialog
          v-model="dialog.show"
          scrollable
          max-width="80%"
        >
          <v-card class="elevation-1">
            <v-card-title class="headline">
              Просмотр изменений
            </v-card-title>
            
            <v-card-text >
              <v-switch v-model="dialog.diff" label="Только различия"></v-switch>
              <div v-if="dialog.diff">
                <pre class="ma-5"><code class="json">{{ dialog.item.diff }}</code></pre>
              </div>
              <div v-else>
                <v-row>
                  <v-col
                    cols="12"
                    md="6" 
                  >
                    <pre class="ma-5"><code class="json">{{ dialog.item.old }}</code></pre>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6" 
                  >
                    <pre class="ma-5"><code class="json">{{ dialog.item.change }}</code></pre>
                  </v-col>
                </v-row>
              </div>      
            </v-card-text>
            <v-card-actions class="grey lighten-4">
              <v-btn
                color="primary"
                @click="dialog.show = false"
              >
                Назад
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.table_item {
  font-size: 0.929rem;
  padding-bottom: 12px;
}
.table_item:first-of-type {
  padding-top: 12px;
}

.table_item__title {
  font-size: 0.929rem;
}
.table_item__subtitle{
  font-size: 0.875rem;
  line-height: 1.2;
  color: #999;
}

</style>
<script>
  //import suggest from '../../libs/suggestions.min.17.12.0.dev.js'
  import suggest from 'suggestions-jquery'
  import moment from 'moment'
  import $ from 'jquery'
  import { diff, addedDiff, deletedDiff, updatedDiff, detailedDiff } from 'deep-object-diff'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      datatable_footer: {
        itemsPerPageText: 'Показывать по', pageText: 'из',
        itemsPerPageAllText: 'Все'
      },
      dialog: {
        show: false,
        diff: true,
        item: {
        },
      },
      headers: [
        {
          sortable: false,
          text: 'Действия',
          value: 'action',
        },
        {
          text: 'Время события',
          value: 'date',
        },
        {
          text: 'Пользователь',
          value: 'user',
        },
        {
          text: 'Тип события',
          value: 'type',
        },
        {
          sortable: false,
          text: 'Фильтровать',
          value: 'filter',
        },
      ],
      items: [],
      search: undefined,
      form: {
        date: {
          from: '',
          to: '',
        },
        type: 0,
        creator: '',
        entity: '',
      },
      select: {
        users: [],
        types: [

        ],
        
      },
      dict: {
      },
      suggestion: {
        bank_name: false,
        bic: false,
        kpp: false,
        inn: false,
        name: false,
      },
    }),
    watch: {
   
    },
    mounted: function () {
      this.select.types = []
      for (let x in this.$store.state.dict.log) {
        this.select.types.push({ value: Number(x), text: this.$store.state.dict.log[x]})     
      }
      console.log(this.select.types)
      this.form.date.from = moment().format('YYYY-MM-DD')
      this.form.date.to = moment().format('YYYY-MM-DD')
      this.axios.post('/api/user/get/',{deleted: true})
        .then(response => {
          if (!response.data.error) {
            this.select.users = response.data.data.map(
              function (obj) {
                return { value: obj.id, text: (obj.surname ? obj.surname + ' ' : '')  + obj.name }
              }
            )
          } else {
            this.$store.commit('snackbar', response.data.data || 'Ошибка при получении данных')
          }
        })
        .catch(e => {
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
      let store_filters = JSON.parse(localStorage.getItem('log_filters') ? localStorage.getItem('log_filters') : '{}')

      if (store_filters) {
        if (store_filters.date) {
          if (store_filters.date.from) {
            this.form.date.from = store_filters.date.from
          }
          if (store_filters.date.to) {
            this.form.date.to = store_filters.date.to
          }
        }
        if (store_filters.type) {
          this.form.type = store_filters.type
        }
        if (store_filters.user) {
          this.form.user = store_filters.user
        }
        /* 
        if (store_filters.name) {
          this.form.name = store_filters.name
        }
        if (store_filters.number) {
          this.form.number = store_filters.number
        }
        if (store_filters.state) {
          this.form.state = store_filters.state
        }
        if (store_filters.id) {
          this.form.id = store_filters.id
        }
        if (store_filters.deleted) {
          this.form.deleted = store_filters.deleted
        } */
      }

      if (this.$route.query.entity) {
        this.form.entity = this.$route.query.entity;
        this.$router.replace({
          query: []
        });
      }
      this.load()
    },
    methods: {
      clear: function () {
        this.form = {
          date: {
            from: '',
            to: '',
          },
          type: 0,
          user: '',
          entity: '',
        },
        this.form.date.from = moment().format('YYYY-MM-DD')
        this.form.date.to = moment().format('YYYY-MM-DD')
        this.load()
      },
      load: function (clear) {
        localStorage.setItem('log_filters', JSON.stringify(this.form))
        this.axios.post('/api/log/list', this.form)
          .then(result => {
            this.form.id = null
            if (!result.data.error) {
              this.items = result.data.data
              for (let x in this.items) {
                this.items[x].date_text= moment(this.items[x].date).format('DD.MM.YYYY HH:mm');
                this.items[x].diff =  diff(JSON.parse(this.items[x].old), JSON.parse(this.items[x].change));
              }
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    }
  }
</script>
